import { ERA_PRIMORDIAL } from './eras/era01_primordial';
import { ERA_CAMBRIAN } from './eras/era02_cambrian';
import { ERA_DINOSAURS } from './eras/era03_dinosaurs';
import { ERA_ICEAGE } from './eras/era04_iceage';
import { ERA_STONEAGE } from './eras/era05_stoneage';
import { ERA_EMPIRES } from './eras/era06_empires';
import { ERA_MEDIEVAL } from './eras/era07_medieval';
import { ERA_INDUSTRIAL } from './eras/era08_industrial';
import { ERA_CYBERPUNK } from './eras/era09_cyberpunk';
import { ERA_ENDOFTIME } from './eras/era10_endoftime';
import { ERA_STUBS } from './eras/stubs';
import { ITEMS } from './items/items';
import { META_UPGRADES, UNLOCKS } from './meta';
import { ContentRegistry } from './registry';
import { CORE_UPGRADES } from './upgrades/core';
import type { EraDef } from './types';

/**
 * Era list. To add an era: create src/content/eras/eraNN_name.ts exporting an
 * EraDef and add it here. Nothing else in the engine needs to change.
 */
export const ERAS: EraDef[] = [ERA_PRIMORDIAL, ERA_CAMBRIAN, ERA_DINOSAURS, ERA_ICEAGE, ERA_STONEAGE, ERA_EMPIRES, ERA_MEDIEVAL, ERA_INDUSTRIAL, ERA_CYBERPUNK, ERA_ENDOFTIME, ...ERA_STUBS];

export function buildRegistry(extraEras: EraDef[] = []): ContentRegistry {
  const reg = new ContentRegistry();
  for (const era of [...ERAS, ...extraEras]) reg.addEra(era);
  reg.addItems(ITEMS);
  reg.addUpgrades(CORE_UPGRADES);
  reg.addMetaUpgrades(META_UPGRADES);
  reg.addUnlocks(UNLOCKS);
  const errors = reg.validate();
  if (errors.length) {
    for (const e of errors) console.error('[content]', e);
    throw new Error(`Content validation failed with ${errors.length} error(s)`);
  }
  return reg;
}
